import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getMailboxJunkEmailConfiguration from '../services/getMailboxJunkEmailConfiguration';
export default action('initMailboxJunkEmailConfiguration')(function initMailboxJunkEmailConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Always reload the junk email configuration because the user may change
                    // the configuration at any time by blocking senders of individual emails
                    _a = store;
                    return [4 /*yield*/, getMailboxJunkEmailConfiguration()];
                case 1:
                    // Always reload the junk email configuration because the user may change
                    // the configuration at any time by blocking senders of individual emails
                    _a.mailboxJunkEmailConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initMailboxJunkEmailConfiguration.js.map